module.exports = __webpack_public_path__ + "media/images/home_unfilled-27a2a1f1373b2356ddc0bfb8487f295f.svg";